module.exports = __webpack_public_path__ + "assets/img/banner8.413ac896.png";